<template>
	<core-layout-headline-with-tabs :tabs="tabs">{{
		$t("organizations")
	}}</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import { can } from "@/permissions/"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const output = [
				{
					name: this.$t("overview"),
					to: {
						name: "OrganizationsDetail",
						params: { id: this.$route.params.id }
					}
				},
				{
					name: this.$t("subscriptions"),
					to: {
						name: "OrganizationSubscriptions",
						params: { id: this.$route.params.id }
					}
				}
			]
			return output
		}
	}
}
</script>
